const e = "datepicker-trigger-", E = "datepicker-", t = "datepicker-fixed-panel-", T = "datepicker-relative-panel-", a = "datepicker-date-panel-", _ = "datepicker-select-month-", D = "datepicker-select-year-", I = [
  {
    key: "relative",
    label: "Relative"
  },
  {
    key: "fixed",
    label: "Fixed Dates"
  },
  {
    key: "date-range",
    label: "Date Range"
  }
];
export {
  a as DATEPICKER_PANEL_DATE_TESTID,
  t as DATEPICKER_PANEL_FIXED_TESTID,
  T as DATEPICKER_PANEL_RELATIVE_TESTID,
  _ as DATEPICKER_SELECT_MONTH_TESTID,
  D as DATEPICKER_SELECT_YEAR_TESTID,
  E as DATEPICKER_TESTID,
  e as DATEPICKER_TRIGGER,
  I as PANEL_TYPES_DICTIONARY
};
//# sourceMappingURL=index.es2485.js.map
